import { GuidePriority } from "../guide";
import type { GuideContext, GuideStep } from "../guide";

/**
 * Captain Bram on Trophies (MP-23, docs/SHOP.md §9.7): the first time the player holds Trophies (a Boss Week tier, a
 * Race medal, an Odyssey map, a weekly track's last node, the Trial, Endless or Iron paid them), one line on where they
 * are spent — once per save, on the lobby, pointing at the Shop tab (Shop → Marks → Trophy Hall, or the Shops' fourth
 * tab). Target required, so it never points at nothing.
 */

export const TrophyTargets = {
  shopTab: ".tab[data-tab=shop]",
} as const;

/** Hub feature tips wait for the first session to be over (scripts/features.ts HubTipsFromCleared). */
const FROM_CLEARED = 2;
const TIP = { kind: "tip", block: "none", needsTarget: true } as const;
const lobbyWithTrophies = (c: GuideContext): boolean =>
  c.screen === "hub" && c.hub !== null && c.hub.sheet === null && c.hub.highestCleared >= FROM_CLEARED && (c.hub.extras.trophies ?? 0) > 0;

export const trophiesHubSteps: readonly GuideStep[] = [
  { ...TIP, id: "hub.trophies", screen: "hub", pose: "cheering", priority: GuidePriority.NewThing, topic: "trophies",
    target: { dom: TrophyTargets.shopTab },
    text: "Your first **Trophies**, Commander! Spend them in the **Trophy Hall**: find it on the **Shop** tab, under **Trophies**.",
    when: lobbyWithTrophies },
];
